const alphaColors = {
  purple10: `rgba(128, 0, 255, .1)`,
  darkPurple10: `rgba(105, 0, 209, .1)`,
  blue10: `rgba(0, 153, 255, .1)`,
  pink10: `rgba(255, 0, 180, .1)`,
  lime10: `rgba(206, 255, 26, .1)`,
}

export const colors = {
  ...alphaColors,
  purple75: `rgba(128, 0, 255, .75)`,
  pink: `rgba(255, 0, 180, 1)`,
  bggray: `rgba(242, 242, 247, 1)`,
  bggray50: `rgba(242, 242, 247, .5)`,
  gray: `#AEAEB2`,
  black: "#000000",
  textGray: `#8E8E93`,
  purple: `rgba(128, 0, 255, 1)`,
  darkPurple: `rgba(105, 0, 209, 1)`,
  blue: `rgba(0, 153, 255, 1)`,
  blue75: `rgba(0, 153, 255, .75)`,
  lightBlue: `#73C7FF`,
  lime: `rgba(206, 255, 26, 1)`,
  green: `#1EDC6A`,
}

export function pickRandomAlphaColor() {
  const keys = Object.keys(alphaColors)
  return alphaColors[keys[(keys.length * Math.random()) << 0]]
}
